import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { CompanyService } from 'src/app/services/company/company.service';
import { AutomaticDebitService } from '../services/automatic-debit.service';
import { NotificationsService } from 'angular2-notifications';
import { AutomaticDebitTableComponent } from './automatic-debit-table/automatic-debit-table.component';
import { Observable } from 'rxjs';
import { YesOrNoComponent } from 'src/app/dialog/yes-or-no/yes-or-no.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { FileService } from 'src/app/services/file.service';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';
import { AuthServiceCustom } from 'src/app/core/auth/authServiceCustom';
import { AutomaticDebitFilesComponent } from './automatic-debit-files/automatic-debit-files.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Company, DatesInput } from '../models/inputModels';
import { DirectDebitContractFile, DirectDebitContractLite } from '../models/directDebitContractLite';

@Component({
    selector: 'automatic-debit',
    templateUrl: './automatic-debit.component.html',
    styleUrls: ['./automatic-debit.component.scss'],
})
export class AutomaticDebitComponent implements OnInit {
    companyBank: Company[] = [];
    companySelected: Company;
    dateSelected: string;
    selectedDates: any[] = [];
    datesFind: DatesInput[] = [];
    fileNameGenerated: string = null;
    loading: boolean = true;
    generated: boolean = false;
    contractList: DirectDebitContractLite[] = [];
    contractListFilter: DirectDebitContractLite[] = [];
    versionFile: number = 4;
    pages = {
        fileRet: { id: 1, title: 'Arquivos RET' },
        fileRem: { id: 2, title: 'Arquivos REM' },
        generateRem: { id: 3, title: 'Gerar REM' },
    };

    breadcrumbItems = [
        { label: 'Arquivos REM', route: 'automatic-debit/rem', active: true },
        { label: 'Arquivos RET', route: 'automatic-debit/ret', active: false },
        { label: 'Importar RET', route: 'automatic-debit/ret/import', active: false },
    ];

    @ViewChild('automaticDebitTableView') automaticDebitTableView!: AutomaticDebitTableComponent;
    @ViewChild('automaticDebitFilesTableView') automaticDebitFilesTableView!: AutomaticDebitFilesComponent;

    constructor(
        private companyService: CompanyService,
        private _cdRef: ChangeDetectorRef,
        private automaticDebitService: AutomaticDebitService,
        private notificationsService: NotificationsService,
        private _dialog: MatDialog,
        private fileService: FileService,
        private sessionBusiness: SessionBusiness,
        private authServiceCustom: AuthServiceCustom,
        private spinner: NgxSpinnerService,
    ) {}

    ngOnInit(): void {
        this.getCompanyBank();
        this.dateSelected = this.getToday();
    }

    loadContractList() {
        let actives = this.datesFind.filter((x) => x.selected).map((x) => x.date);
        if (actives.length > 0) {
            this.contractListFilter = this.contractList.filter((x) =>
                actives.includes(new Intl.DateTimeFormat('pt-BR').format(new Date(x.dueDateBillet))),
            );
        } else {
            this.contractListFilter = [];
        }
        this.automaticDebitTableView.loadPaginator();
    }

    getCompanyBank() {
        this.showLoad(true);
        let typeBank = 1;
        this.companyService.GetByTypeId(typeBank).subscribe((result: any) => {
            if (result && result.success) {
                this.companyBank = result.data;
                this.companyBank = this.companyBank
                    .sort((a, b) => a.code.localeCompare(b.code))
                    .filter((x) => [1, 33, 237, 70].includes(parseInt(x.code)));
                this.companySelected = this.companyBank[0];
            } else {
                this.companyBank = [];
                this.notificationsService.warn('Nenhuma conta de convênio foi encontrado');
            }
            this.showLoad(false);
        });
    }

    btnCancel() {
        this.dateSelected = this.getToday();
        this.emptDataToFilter();
        this.loadContractList();
        this._cdRef.detectChanges();
    }

    showLoad(value: boolean) {
        this.loading = value;
        if (this.loading) {
            this.spinner.show();
        } else {
            this.spinner.hide();
        }
        this._cdRef.detectChanges();
    }

    getToday(): string {
        return new Date().toISOString().split('T')[0]; // Retorna no formato YYYY-MM-DD
    }

    emptDataToFilter() {
        this.fileNameGenerated = '';
        this.contractList = [];
        this.contractListFilter = [];
        this.datesFind = [];
        this.generated = false;
        this.versionFile = 4;
    }

    enterFilePages() {
        this.emptDataToFilter();
    }

    filterDate() {
        this.emptDataToFilter();
        this.showLoad(true);
        this.generated = false;

        this.automaticDebitService
            .GetAuthorizedByDate(
                this.dateSelected,
                this.sessionBusiness.LegalEntityIdContext,
                parseInt(this.companySelected.code),
            )
            .subscribe(
                (result) => {
                    if (!result || !result.success || result?.data?.dates.length == 0) {
                        this.notificationsService.warn('Nenhum registro foi encontrado');
                    }
                    this.contractList = result.data?.contracts;
                    this.contractListFilter = this.contractList;
                    result?.data?.dates.forEach((item: any) => {
                        this.datesFind.push({ date: item, selected: true });
                    });

                    this.selectedDates = this.datesFind;
                    this.loadContractList();
                    this.showLoad(false);
                },
                (error) => {
                    console.log('error', error);
                    this.notificationsService.warn(error?.error);
                    this.showLoad(false);
                },
            );
    }

    generateFile(): void {
        if (this.generated) {
            this.notificationsService.warn('Arquivo já registrado, consulte novamente');
            return;
        }

        if (this.contractListFilter.length == 0) {
            this.notificationsService.warn('Não há itens para gerar');
            return;
        }

        this.yesOrNoDialog('Atenção', 'Deseja confirmar a geração do arquivo?').subscribe((result) => {
            if (result) {
                this.showLoad(true);
                let params: DirectDebitContractFile = {
                    legalEntityId: this.sessionBusiness.LegalEntityIdContext,
                    CompanyCode: this.companySelected.code,
                    CompanyName: this.companySelected.name,
                    userName: this.authServiceCustom.userName,
                    items: this.contractListFilter,
                    versionFile: this.versionFile.toString(),
                };

                this.automaticDebitService.CreateFile(params).subscribe(
                    (response) => {
                        this.fileService.downloadFile(response);
                        this.fileNameGenerated = response.fileName;
                        this.generated = true;
                        this.notificationsService.success(`Arquivo: gerado com sucesso!`);
                        this.showLoad(false);
                    },
                    (error) => {
                        console.error('Erro', error);
                        this.notificationsService.warn(`Erro ao criar o arquivo: \n \n ${error}`);
                        this.showLoad(false);
                    },
                );
            }
        });
    }

    classSelected(date: DatesInput) {
        if (date.selected) {
            return 'text-success';
        } else {
            return 'text-danger';
        }
    }

    private yesOrNoDialog(title: string, text: string): Observable<any> {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = 260;
        dialogConfig.data = {
            title: title,
            text: text,
        };
        const dialogRef = this._dialog.open(YesOrNoComponent, dialogConfig);
        return dialogRef.afterClosed();
    }

    toggleSelection(dateString: DatesInput) {
        dateString.selected = !dateString.selected;
        this.loadContractList();
    }
}
